import { createContext } from "react"

import { ColorLibObj, MapPropV2 } from "../../../utils/types"

interface ContextType {
  imageData: ImageData | {}
  mapProp: MapPropV2 | null
  colorLib: ColorLibObj[]
}

export const ViewerContext = createContext<ContextType>({
  imageData: {},
  mapProp: null,
  colorLib: []
})